import config from '@/language/es/components/config';
import filters from '@/language/es/components/filters';
import models from '@/language/es/components/cards/models';
import filter from '@/language/es/components/filter';
import post from '@/language/es/components/post';
import PublishSwitch from '@/language/es/components/PublishSwitch';
import Impress from '@/language/es/components/Impress';
import OperatorsLogs from '@/language/es/components/OperatorsLogs';
import CopyToClipboard from '@/language/es/components/CopyToClipboard';
import AddCardModal from '@/language/es/components/AddCardModal';
import HiddenCardsModal from '@/language/es/components/HiddenCardsModal';
import RemoveCardModal from '@/language/es/components/RemoveCardModal';
import CardModal from '@/language/es/components/CardModal';
import DashCardsContainer from '@/language/es/components/DashCardsContainer';
import GlobalFilter from '@/language/es/components/GlobalFilter';
import GlobalFilterModal from '@/language/es/components/GlobalFilterModal';
import GlobalFilterSummary from '@/language/es/components/GlobalFilterSummary';
import Badge from '@/language/es/components/Badge';
import DashFilterBar from '@/language/es/components/DashFilterBar';
import AddDescriptionModal from '@/language/es/components/AddDescriptionModal';
import AnnotationTextCard from '@/language/es/components/AnnotationTextCard';
import MenuBar from '@/language/es/components/MenuBar';
import HelpButton from '@/language/es/components/HelpButton';
import PublicAccessModal from '@/language/es/components/PublicAccessModal';
import Onboarding from '@/language/es/components/Onboarding';
import EnvironmentInfo from '@/language/es/components/EnvironmentInfo';
import AnnotationImageCard from '@/language/es/components/AnnotationImageCard';
import FileImporter from '@/language/es/components/FileImporter';
import ImportHistory from '@/language/es/components/ImportHistory';
import TextFilter from '@/language/es/components/TextFilter';
import CustomerServiceRatings from '@/language/es/components/CustomerServiceRatings';
import OptionsButton from '@/language/es/components/OptionsButton';
import StatusTable from '@/language/es/components/StatusTable';
import UserMenu from '@/language/es/components/UserMenu';
import ComponentBuildModal from '@/language/es/components/ComponentBuildModal';
import BlipMessageVolumeInPeriod from '@/language/es/components/BlipMessageVolumeInPeriod';
import BlipEngagedAndNonEngagedContacts from '@/language/es/components/BlipEngagedAndNonEngagedContacts';
import BlipActiveMessagesByChannel from '@/language/es/components/BlipActiveMessagesByChannel';
import ConsolidatedCSATPieChart from '@/language/es/components/ConsolidatedCSATPieChart';
import BaseChannelPieChartOwnedEarned from '@/language/es/components/BaseChannelPieChartOwnedEarned';
import CustomErrorMessage from '@/language/es/components/CustomErrorMessage';
import GPTSuggestions from '@/language/es/components/GPTSuggestions';
import SentmentByTagTreeview from '@/language/es/components/SentmentByTagTreeview';
import LoversTable from '@/language/es/components/LoversTable';
import BlipActiveCampaignComponents from '@/language/es/components/BlipActiveCampaignComponents';
import BlipOpenTicketsTable from '@/language/es/components/BlipOpenTicketsTable';
import BlipMonitoringAttendantsTable from '@/language/es/components/BlipMonitoringAttendantsTable';
import BlipReportsTicketsInTime from '@/language/es/components/BlipReportsTicketsInTime';
import BlipMonitoringTeamsTable from '@/language/es/components/BlipMonitoringTeamsTable';
import BlipDeskComponents from '@/language/es/components/BlipDeskComponents';
import BlipReportsTable from '@/language/es/components/BlipReportsTable';
import InterestLovers from '@/language/es/components/InterestLovers';
import CommentSheetImporter from '@/language/es/components/CommentSheetImporter';
import BlipTagsMetricsTable from '@/language/es/components/BlipTagsMetricsTable';
import BlipWaitingTicketsTable from '@/language/es/components/BlipWaitingTicketsTable';
import AverageSACTimePieChart from '@/language/es/components/AverageSACTimePieChart';
import PerformanceByTimeMatrix from '@/language/es/components/PerformanceByTimeMatrix';
import PerformanceByChannel from '@/language/es/components/PerformanceByChannel';
import ImportPostTags from '@/language/es/components/ImportPostTags';
import GlobalFilterMenu from '@/language/es/components/GlobalFilterMenu';
import CallsIncomingAttended from '@/language/es/components/CallsIncomingAttended';
import AutoReload from '@/language/es/components/AutoReload';
import ChooseCardMenu from '@/language/es/components/ChooseCardMenu';
import DateFilter from '@/language/es/components/DateFilter';
import ResizeModal from '@/language/es/components/ResizeModal';
import DashTopBar from '@/language/es/components/DashTopBar';
import TopPosts from '@/language/es/components/TopPosts';
import PropTopPosts from '@/language/es/components/PropTopPosts';
import PropTopCommentsPosts from '@/language/es/components/PropTopCommentsPosts';
import TimelineProprietaryPosts from '@/language/es/components/TimelineProprietaryPosts';
import EngagementMatrix from '@/language/es/components/EngagementMatrix';
import SentimentByTagTreeviewFilter from '@/language/es/components/SentimentByTagTreeviewFilter';
import StockVsSentimentLineChart from '@/language/es/components/StockVsSentimentLineChart';
import StockVsSocialLineChart from '@/language/es/components/StockVsSocialLineChart';
import SacReportCallsQuantity from '@/language/es/components/SacReportCallsQuantity';
import MultiplePieChart from '@/language/es/components/MultiplePieChart';
import GranularityDropDown from '@/language/es/components/GranularityDropDown';
import VariationOfFanBaseChart from '@/language/es/components/VariationOfFanBaseChart';
import GoogleMyBusinessRatingsByStars from '@/language/es/components/GoogleMyBusinessRatingsByStars';

export default {
  config,
  filters,
  models,
  filter,
  post,
  PublishSwitch,
  CardModal,
  DashCardsContainer,
  CopyToClipboard,
  AddCardModal,
  HiddenCardsModal,
  RemoveCardModal,
  Impress,
  GlobalFilter,
  GlobalFilterModal,
  GlobalFilterSummary,
  OperatorsLogs,
  Badge,
  DashFilterBar,
  AddDescriptionModal,
  AnnotationTextCard,
  MenuBar,
  HelpButton,
  PublicAccessModal,
  Onboarding,
  EnvironmentInfo,
  AnnotationImageCard,
  FileImporter,
  ImportHistory,
  TextFilter,
  CustomerServiceRatings,
  OptionsButton,
  StatusTable,
  UserMenu,
  ComponentBuildModal,
  BlipMessageVolumeInPeriod,
  BlipEngagedAndNonEngagedContacts,
  BlipActiveMessagesByChannel,
  ConsolidatedCSATPieChart,
  BaseChannelPieChartOwnedEarned,
  CustomErrorMessage,
  GPTSuggestions,
  SentmentByTagTreeview,
  LoversTable,
  BlipActiveCampaignComponents,
  BlipReportsTicketsInTime,
  BlipDeskComponents,
  BlipReportsTable,
  InterestLovers,
  CommentSheetImporter,
  BlipOpenTicketsTable,
  BlipMonitoringAttendantsTable,
  BlipMonitoringTeamsTable,
  BlipTagsMetricsTable,
  BlipWaitingTicketsTable,
  AverageSACTimePieChart,
  PerformanceByTimeMatrix,
  PerformanceByChannel,
  ImportPostTags,
  GlobalFilterMenu,
  CallsIncomingAttended,
  AutoReload,
  ChooseCardMenu,
  DateFilter,
  ResizeModal,
  DashTopBar,
  TopPosts,
  PropTopPosts,
  PropTopCommentsPosts,
  TimelineProprietaryPosts,
  EngagementMatrix,
  SentimentByTagTreeviewFilter,
  StockVsSentimentLineChart,
  StockVsSocialLineChart,
  SacReportCallsQuantity,
  MultiplePieChart,
  GranularityDropDown,
  VariationOfFanBaseChart,
  GoogleMyBusinessRatingsByStars,
};
